import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  CardContent,
  Grid,
  Card as MuiCard,
  LinearProgress,
  Button,
} from "@mui/material";

import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";

import { getNextCode,sendToZatca } from "src/services/INV/invService";
import { DefaultService } from "src/services/defaultService";
import { toast } from "react-toastify";

import { parseAndRound } from "src/utils/amUtils";
import { getCaption } from "src/utils/dictionary";
import _ from "lodash";

import AMIndexList from "src/pages/components/AMIndexList";
import InvTrxFooter from "./InvTrxFooter";
import InvTrxExpenses from "./InvTrxExpenses";
import LegerWithSubLedgers from "src/pages/pages/gaTrx/LegerWithSubLedgers";
import {
  getLedgers,
} from "src/services/GA/gaService";
const Card = styled(MuiCard)(spacing);

function InvTrxPage({ menuItemCode }) {
  const defaultService = new DefaultService("INV_Trx");
  const [ledgers, setLedgers] = useState([]);
  const [showExpensesEditor, setShowExpensesEditor] = useState(false);

  //#region Api Calls
  const getNextCodeFunc = async () => {
    if (values && values.trxDate) {
       const { data } = await getNextCode(menuItemCode, values.trxDate, values.invTrxTypeID, values.storeID);
      return data || "";
    } else return "";
  };

  const getByIdFunc = async (id) => {
    const { data } = await defaultService.get(menuItemCode, id);
   //Remove id if rendered from server to keep id as it comes from url and not enter in infinite loop
    //also if not remoced copy form will not work
    if (data) {
      delete data.id;
      delete data.ID;
      delete data.Id;
      delete data.iD;
    }
    return data;
  };

  const sendToZatcaFunc = async (id) => {
    const { data } = await sendToZatca(menuItemCode, id);
    return data;
  };
  
  const saveFormFunction = async (menuItemCode, formData) => {
    if (
      !(
        formControls["detailsSection"] &&
        formControls["detailsSection"].isHidden
      ) &&
      formData.trxFooter
    ) {
      const totalCredit = parseAndRound(
        _.sumBy(formData.trxFooter, function (o) {
          return parseAndRound(o.displayCredit);
        }),
        4
      );
      const totalDebit = parseAndRound(
        _.sumBy(formData.trxFooter, function (o) {
          return parseAndRound(o.displayDebit);
        }),
        4
      );

      if (totalCredit !== totalDebit) {
        toast.error(getCaption("total_credit_must_equal_total_debit"));
        return false;
      }
    }

    const { data } = await defaultService.save(menuItemCode, formData);
    return data;
  };

  const deleteFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.delete(menuItemCode, formData);
    return data;
  };
  //#endRegion

  const getDefaulteValues = () => {
    const today =
      new Date().getFullYear().toString() +
      "/" +
      (new Date().getMonth() + 1).toString() +
      "/" +
      new Date().getDate().toString();

    const initialVals = { trxDate: today, cash: false,UUID: crypto.randomUUID().toUpperCase() };
    return initialVals;
  };

  const {
    state: values,
    errors: formErrors,
    handleSetState,
    indexColumns,
    renderFormHeader,
    renderFormInput,
    preLoaded,
    formControls,
    filterControls,
    handleSelectedIndexChange,
  } = useForm({
    menuItemCode: menuItemCode,
    nextCodeField: "number",
    getNextCodeFunc: getNextCodeFunc,
    getByIdFunc: getByIdFunc,
    saveFunction: saveFormFunction,
    deleteFunction: deleteFunction,
    defaulteValuesFunc: getDefaulteValues,
  });

  useEffect(() => {
    if (!menuItemCode || !preLoaded || !values.trxDate) return;
    if (!values.id || values.id.toLowerCase() !== "add".toLowerCase()) return;
    (async () => {
      try {
        const nextCode = await getNextCodeFunc();
        handleSetState({ number: nextCode });
      } catch (error) {
        console.log(error.message);
      }


       const { data } = await getLedgers(menuItemCode);
            let d = [];
            try {
              d = JSON.parse(data);
            } catch (error) {}
      
            setLedgers(d || []);
    })();
  }, [menuItemCode, preLoaded, values.trxDate,values.invTrxTypeID, values.storeID]);

  //#region Save Details
  const handleSetTrxFooter = (newTrxFooter) => {
    const newState = { ...values };
    newState.trxFooter = [...newTrxFooter];
    handleSetState(newState);
  };

  const handleSetTrxExpenses = (newTrxExpenses) => {
    const newState = { ...values };
    newState.trxExpenses = [...newTrxExpenses];
    handleSetState(newState);
  };
  //#endregion

  const hasTrxExpenses = !!(values.trxExpenses && values.trxExpenses.length);
  const showExpensesSection = hasTrxExpenses || showExpensesEditor;
  const isEditMode =
    !values.id || values.id.toLowerCase() !== "add".toLowerCase();
  
    if (!preLoaded) return <LinearProgress my={2} />;

  const mainData = (
    <Card mb={6}>
      <CardContent>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              {!(formControls["storeID"] && formControls["storeID"].isHidden) &&
                renderFormInput("storeID", Enums.ControlType.AutoSearch, {
                  disabled: isEditMode,
                  autoSelectSingleOption: true,
                })}
              {renderFormInput("trxDate", Enums.ControlType.DatePicker)}
              <Grid item xs={12} md={6} sm={6} lg={3} xl={3}>
                <Grid container spacing={4}>
                  {renderFormInput(
                    "number",
                    Enums.ControlType.TextField,
                    {
                      disabled: true,
                    },
                    {
                      xs: 12,
                      sm: 12,
                      md: 8,
                      lg: 8,
                      xl: 8,
                    }
                  )}
                  {renderFormInput("cash", Enums.ControlType.CheckBox, null, {
                    xs: 12,
                    sm: 12,
                    md: 4,
                    lg: 4,
                    xl: 4,
                  })}
                </Grid>
              </Grid>
              {renderFormInput("currencyID", Enums.ControlType.AutoSearch)}
              {renderFormInput("currencyRate")}
              {renderFormInput("customerID", Enums.ControlType.AutoSearch)}
              {renderFormInput("supplierID", Enums.ControlType.AutoSearch)}
            </Grid>
          </Grid>

          {!(formControls["ledgerID"] && formControls["ledgerID"].isHidden) && (
            <>
              {/* <Grid item xs={12}>
                <Typography variant="button" gutterBottom color="primary">
                  {(formControls["creditCaption"] &&
                    formControls["creditCaption"].caption) ||
                    "Credit"}
                </Typography>
              </Grid> */}
              <Grid item xs={12}>
              <Grid container spacing={4}>
                  <LegerWithSubLedgers
                    ledgers={ledgers}
                    menuItemCode=""
                    formControls={formControls || {}}
                    errors={formErrors || {}}
                    onChange={handleSelectedIndexChange}
                    ledgerId={values["ledgerID"] || ""}
                    subLedgerAId={values["subLedgerID_A"] || ""}
                    subLedgerBId={values["subLedgerID_B"] || ""}
                    subLedgerCId={values["subLedgerID_C"] || ""}
                    subLedgerDId={values["subLedgerID_D"] || ""}
                    ledgerIdFieldName="ledgerID"
                    subLedgerAIdFieldName="subLedgerID_A"
                    subLedgerBIdFieldName="subLedgerID_B"
                    subLedgerCIdFieldName="subLedgerID_C"
                    subLedgerDIdFieldName="subLedgerID_D"
                  />
                </Grid>
              </Grid>
            </>
          )}

          {renderFormInput("costCenterID", Enums.ControlType.AutoSearch)}
          {renderFormInput("salesPersonID", Enums.ControlType.AutoSearch)}
          {renderFormInput("notes", Enums.ControlType.TextField, null, {
            xs: 12,
            sm: 12,
            md: 6,
            lg: 6,
            xl: 6,
            style: { paddingBottom: 5, paddingTop: 5 },
          })}
          {isEditMode && (
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={async () => {
                  try {
                    const response = await sendToZatcaFunc(values.id);
                    toast.success(response?.message || "Sent to Zatca successfully");
                  } catch (error) {
                    toast.error(error?.message || "Failed to send to Zatca");
                  }
                }}
              >
                Send to Zatca
              </Button>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <React.Fragment>
      {renderFormHeader()}
      {!values.id && indexColumns && !!indexColumns.length && (
        <AMIndexList
          key={indexColumns.length}
          columns={indexColumns}
          filterControls={filterControls}
          menuItemCode={menuItemCode}
          getAll={defaultService.getAll}
        />
      )}
      {!!values.id && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {mainData}
          </Grid>
          {! (
            formControls["detailsSection"] &&
            formControls["detailsSection"].isHidden
          ) && (
            <Grid item xs={12}>
              <InvTrxFooter
                formControls={formControls}
                tableData={values.trxFooter || []}
                setTableData={handleSetTrxFooter}
                ledgers={ledgers}
                menuItemCode={menuItemCode}
              />
            </Grid>
          )}
          {! (
            formControls["expensesSection"] &&
            formControls["expensesSection"].isHidden
          ) && (
            <>
              {showExpensesSection ? (
                <Grid item xs={12}>
                  <InvTrxExpenses
                    formControls={formControls}
                    tableData={values.trxExpenses || []}
                    setTableData={handleSetTrxExpenses}
                    title="Expenses"
                    menuItemCode={menuItemCode}
                  />
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    onClick={() => setShowExpensesEditor(true)}
                  >
                    Extra Expense / Discount
                  </Button>
                </Grid>
              )}
            </>
          )}
        </Grid>
      )}
    </React.Fragment>
  );
}

export default InvTrxPage;
